import { inferRouterOutputs } from "@trpc/server";

import { AppRouterType, trpc } from "../../helpers/trpc";

export type EmailContentBuilderType =
  inferRouterOutputs<AppRouterType>["getEmailContentWithFormData"]["emailContent"] & {
    attachment: {
      fileUrl: string;
    };
  };

export const useGetEmailContent = (emailContentId?: string) => {
  const {
    data: getEmailContentWithFormData,
    refetch,
    isLoading,
  } = trpc.getEmailContentWithFormData.useQuery(
    { emailContentId: emailContentId as string },
    { enabled: Boolean(emailContentId), cacheTime: 0 }
  );

  if (!getEmailContentWithFormData?.emailContent) {
    return { emailContent: undefined, refetchEmailContent: refetch };
  }

  const emailContent: EmailContentBuilderType = {
    ...getEmailContentWithFormData.emailContent,
    attachment: {
      fileUrl: getEmailContentWithFormData.emailContent?.attachmentUrl || "",
    },
  };

  const linkedForm = getEmailContentWithFormData.linkedForm;

  const refetchEmailContent = async () => {
    if (emailContentId) {
      await refetch();
    }
  };

  return { emailContent, refetchEmailContent, isLoading, linkedForm };
};
